module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pc-header"
    }
  }, [_c('logo-in-header', {
    staticClass: "pull-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    attrs: {
      "id": "right-navbar"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "header-list dropdown"
  }, [_c('a', {
    staticClass: "nickname main-link",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/dashboard/avatar_2x.png",
      "alt": "Account: "
    }
  }), _vm._v(_vm._s(_vm.nickname) + "\n          "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('account-info-list')], 1), _vm._v(" "), _c('li', {
    staticClass: "header-list"
  }, [_c('router-link', {
    staticClass: "main-link",
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('index')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "header-list"
  }, [_c('router-link', {
    attrs: {
      "to": "/download"
    }
  }, [_vm._v(_vm._s(_vm.$t('download')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "header-list"
  }, [_c('router-link', {
    attrs: {
      "to": "/faq"
    }
  }, [_vm._v(_vm._s(_vm.$t('faq')))])], 1), _vm._v(" "), _c('li', [_c('Choose-lang', {
    attrs: {
      "className": 'dashboard-header'
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b8ed403!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plexHeader/userCenterHeader/UserCenterHeaderPc.vue
// module id = 1289
// module chunks = 1